define("shared/utils/facebook-product", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  class FacebookProduct {
    constructor(data, locale) {
      this.locale = locale;
      this.data = data;
      this.reviewStatuses = {
        APPROVED: 'approved',
        REJECTED: 'rejected',
        PENDING: ['', 'no_review', 'outdated', 'pending']
      };
    }
    get id() {
      return this.data.product_id || this.data.id;
    }
    get name() {
      return this.data.product_name || this.data.name;
    }
    get imageUrl() {
      return this.data.image_url;
    }
    get displayPrice() {
      return this.locale.formatCurrency(this.price);
    }
    get reviewStatus() {
      return this.data.review_status;
    }
    get isApproved() {
      return this.reviewStatuses.APPROVED.includes(this.reviewStatus);
    }
    get isRejected() {
      return this.reviewStatuses.REJECTED.includes(this.reviewStatus);
    }
    get isPending() {
      return this.reviewStatuses.PENDING.includes(this.reviewStatus);
    }
    get isDisabled() {
      return !this.isApproved;
    }
  }
  _exports.default = FacebookProduct;
});